/* Dalia Bella: si el color elegido no existe en la talla marcada, marca la primera talla disponible */
(function () {
  function grupos() {
    return Array.prototype.slice.call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, fieldset.variant-option'));
  }
  function arreglar() {
    var gs = grupos(); if (gs.length < 2) return;
    var talla = gs.find(function (f) { var l = f.querySelector('legend'); return l && /talla|copa|tac/i.test(l.textContent); }) || gs[gs.length - 1];
    var marcada = talla.querySelector('input:checked');
    if (!marcada) return;
    var mal = marcada.dataset.optionAvailable === 'false' || marcada.disabled || marcada.getAttribute('aria-disabled') === 'true' || (marcada.closest('label') && /disabled|unavailable/.test(marcada.closest('label').className));
    if (!mal) return;
    var ok = Array.prototype.slice.call(talla.querySelectorAll('input')).find(function (i) {
      var l = i.closest('label');
      return i.dataset.optionAvailable !== 'false' && !i.disabled && !(l && /disabled|unavailable/.test(l.className));
    });
    if (ok && ok !== marcada) ok.click();
  }
  // Las tallas van de menor a mayor; al entrar sin variante elegida, se marca la M (o la 38 en calzado) si está disponible.
  function marcarM() {
    if (/[?&]variant=/.test(location.search)) return;
    var talla = grupos().find(function (f) { var l = f.querySelector('legend'); return l && /talla/i.test(l.textContent); });
    if (!talla) return;
    var marcada = talla.querySelector('input:checked');
    var m = talla.querySelector('input[value="M"]') || talla.querySelector('input[value="38"]');
    if (!m || m === marcada || m.dataset.optionAvailable === 'false' || m.disabled) return;
    m.click();
  }
  // Aviso junto al selector cuando la talla elegida no está en la tabla de medidas del proveedor.
  function avisoTalla() {
    var talla = grupos().find(function (f) { var l = f.querySelector('legend'); return l && /talla/i.test(l.textContent); });
    if (!talla) return;
    var marcada = talla.querySelector('input:checked');
    var filas = Array.prototype.map.call(document.querySelectorAll('.db-tallas tbody th'), function (th) { return th.textContent.trim(); });
    var sinTabla = !filas.length && /no publica tabla de medidas/.test(document.body.textContent);
    var texto = '';
    if (marcada && filas.length && filas.indexOf(marcada.value) === -1) texto = 'De la talla ' + marcada.value + ' el proveedor no da medidas.';
    else if (marcada && sinTabla) texto = 'Esta prenda no tiene tabla de medidas del proveedor.';
    var nota = talla.parentNode.querySelector('.db-talla-aviso');
    if (!texto) { if (nota) nota.remove(); return; }
    if (!nota) { nota = document.createElement('p'); nota.className = 'db-talla-aviso'; talla.insertAdjacentElement('afterend', nota); }
    nota.innerHTML = texto + ' <a href="mailto:hola@belladalia.com?subject=' + encodeURIComponent('Medidas de la talla ' + marcada.value + ' de «' + document.title.split(' – ')[0] + '»') + '">Pregúntanos por correo</a> antes de pedirla.';
  }
  function inicio() { marcarM(); setTimeout(avisoTalla, 600); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicio); else inicio();
  document.addEventListener('change', function (e) {
    if (!e.target.closest('fieldset')) return;
    setTimeout(arreglar, 400); setTimeout(arreglar, 1000);
    setTimeout(avisoTalla, 700); setTimeout(avisoTalla, 1300);
  });
})();
